var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTermsAccepted(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.90625 0.875 0 2 0H7V4C7 4.5625 7.4375 5 8 5H12V6.21875C9.6875 6.875 8 9 8 11.5C8 13.375 8.90625 15 10.2812 16C10.1875 16 10.0938 16 10 16H2C0.875 16 0 15.125 0 14V2ZM12 4H8V0L12 4ZM9 11.5C9 9.90625 9.84375 8.4375 11.25 7.625C12.625 6.8125 14.3438 6.8125 15.75 7.625C17.125 8.4375 18 9.90625 18 11.5C18 13.125 17.125 14.5938 15.75 15.4062C14.3438 16.2188 12.625 16.2188 11.25 15.4062C9.84375 14.5938 9 13.125 9 11.5ZM15.5938 10.1562C15.4062 9.96875 15.0625 9.96875 14.875 10.1562L13 12.0625L12.0938 11.1562C11.9062 10.9688 11.5625 10.9688 11.375 11.1562C11.1875 11.3438 11.1875 11.6875 11.375 11.875L12.625 13.125C12.8125 13.3125 13.1562 13.3125 13.3438 13.125L15.5938 10.875C15.7812 10.6875 15.7812 10.3438 15.5938 10.1562Z",
    fill: "#465365"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsAccepted);
export default __webpack_public_path__ + "static/media/terms_accepted.e3f9bb1b6b1ea2bcf7633c9abd16d940.svg";
export { ForwardRef as ReactComponent };